import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { BookingsScreen, type BookingsSearch } from "../components/bookings/BookingsScreen";

const searchSchema = z.object({
  date_from: z.string().optional(),
  date_to: z.string().optional(),
  status: z.array(z.enum(["confirmed", "checked_in", "no_show", "cancelled"])).optional(),
  therapist_id: z.number().int().optional(),
  sort: z.enum(["starts_at", "-starts_at"]).default("starts_at"),
  page: z.number().int().min(1).default(1),
  page_size: z.number().int().min(1).max(100).default(50),
  selected: z.string().uuid().optional(),
});

export const Route = createFileRoute("/_auth/bookings/")({
  staticData: { titleKey: "nav.bookings", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 4 },
  validateSearch: searchSchema,
  component: BookingsRoute,
});

function BookingsRoute() {
  const search = Route.useSearch() as BookingsSearch;
  const navigate = useNavigate({ from: "/bookings/" });

  return (
    <BookingsScreen
      search={search}
      onNavigate={(next) => {
        navigate({ search: (prev) => ({ ...prev, ...next }) as never });
      }}
    />
  );
}
